import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../../services/API/auth/auth.service';
import { Router, ActivatedRoute, ParamMap  } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { NotificationServiceService } from './../../../../services/notification-service/notification-service.service';

@Component({
    selector: 'app-changepassword',
    templateUrl: './changepassword.component.html',
    styleUrls: ['./changepassword.component.css'],
    standalone: false
})
export class ChangepasswordComponent implements OnInit {

  token: string = "";

  loginForm: UntypedFormGroup;
  loginPassword: string = "";
  loginPassword2: string = "";

  loading: boolean = false;

  constructor(private fb: UntypedFormBuilder, private route: ActivatedRoute, public router: Router, private authService: AuthService, private notificationService: NotificationServiceService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.token = params['token'];
      console.log(this.token);
    });

    this.loginForm = this.fb.group({
      loginPassword: [this.loginPassword, [Validators.required, Validators.minLength(8), Validators.maxLength(255)]],
      loginPassword2: [this.loginPassword2, [Validators.required, Validators.minLength(8), Validators.maxLength(255)]],
    });
  }

  changePassword() {
    const {valid} = this.loginForm;
    if(valid){
      this.loading = true;

      setTimeout(()=>{
        this.loading = false;
      }, 5000);

      var password = this.loginForm.controls['loginPassword'].value;
      var password2 = this.loginForm.controls['loginPassword'].value;

      if(password === password2){
        this.authService.changePassword(password, password2, this.token).subscribe(data => {

          this.loading = false;
          this.notificationService.openSnackBar("¡Contraseña modificada!");

          this.router.navigateByUrl('/login');

        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.loading = false;
        });
      }else{
        this.notificationService.openSnackBar("¡Las contraseñas deben ser iguales!");
      }
    }
  }

}
